module.exports = __webpack_public_path__ + "img/wuyou.f57722d9.png";